<ng-container>
  <ion-header class="ion-no-border header">
    <ion-toolbar>
      <ion-label class="title" data-cy="select-customer-label">
        {{ 'i18n.payments.paymentDashboard.selectSellers' | translate }}
      </ion-label>
      <ion-buttons slot="end" *ngIf="isDesktop">
        <ion-button data-cy="close-modal-button" (click)="close()">
          <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <cdk-virtual-scroll-viewport
      class="territory-list"
      itemSize="79"
      minBufferPx="800"
      maxBufferPx="1000"
    >
      <ion-list class="territory-list" *ngIf="dsmInfo?.length">
        <ion-item>
          <ion-label class="list-row">
            <div class="bold-label">
              {{ 'i18n.payments.paymentDashboard.myCustomers' | translate }}
            </div>
          </ion-label>
          <ion-checkbox
            slot="end"
            [checked]="myTerritorySelected"
            (ionChange)="myTerritorySelected = !myTerritorySelected"
          >
          </ion-checkbox>
        </ion-item>
        <ion-item>
          <ion-label class="list-row" *ngIf="dsmInfo?.length">
            <div class="bold-label">
              {{ 'i18n.payments.paymentDashboard.mySellers' | translate }}
            </div>
            <div class="select-all-text">
              {{
                (allSelected
                  ? 'i18n.common.deselectAll'
                  : 'i18n.common.selectAll'
                ) | translate
              }}
            </div>
          </ion-label>
          <ion-checkbox
            slot="end"
            [checked]="allSelected"
            (ionChange)="toggleSelectAll()"
          >
          </ion-checkbox>
        </ion-item>
        <ion-item *cdkVirtualFor="let territory of dsmInfo; let i = index">
          <ion-label class="list-row">
            <div>
              <div class="other-territory-label">
                {{ formatCustomerName(territory) }}
              </div>
              <div class="territory-route-number">
                {{ formatRouteNumbers(territory) }}
              </div>
            </div>
          </ion-label>
          <ion-checkbox
            slot="end"
            [checked]="selectedTerritories.has(i)"
            (ionChange)="selectTerritory(i)"
          >
          </ion-checkbox>
        </ion-item>
      </ion-list>
    </cdk-virtual-scroll-viewport>
  </ion-content>

  <ion-footer
    class="customer-selection-footer"
    [ngClass]="
      isTablet
        ? 'ion-footer-modal-tablet'
        : isMobile
          ? 'ion-footer-modal-mobile'
          : 'ion-footer-modal-desktop'
    "
  >
    <div class="buttons-group">
      <ion-button
        class="usf-outline-green-button"
        (click)="close()"
        data-cy="cancel-button"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>

      <ion-button
        class="usf-fill-green-button"
        data-cy="save-button"
        (click)="saveTerritorySelection()"
        [disabled]="!selectedTerritories.size && !myTerritorySelected"
      >
        {{ 'i18n.common.save' | translate }}
      </ion-button>
    </div>
  </ion-footer>
</ng-container>
